import React from 'react';
import { FEATURES } from '@Constants/rx-ui/constants';
import Auth from '@Services/Auth';
import { isNewAuthorSearchFilterEnabled } from '@Containers/ResultsFilters/utils';
import { AUTHORS_OF_SCI_DOC_FILTER_ID } from '@Containers/ResultsFilters/ResultsFiltersConstants';

const withFeatureSwitchers = (Component) => {
  function WithFeatureSwitchersHOC(props) {
    const { filter } = props;
    const customGroupsRadioButtonsFeatureEnabled = Auth.isFeatureEnabled(FEATURES.enableJournalTitleRadioButtons);
    const newAuthorSearchFilterEnabled = isNewAuthorSearchFilterEnabled(filter?.get('id'));
    const isAuthorsOfSciDocFilter = filter?.get('id') === AUTHORS_OF_SCI_DOC_FILTER_ID;
    return (
      <Component
        {...props}
        customGroupsRadioButtonsFeatureEnabled={customGroupsRadioButtonsFeatureEnabled}
        newAuthorSearchFilterEnabled={newAuthorSearchFilterEnabled}
        isAuthorsOfSciDocFilter={isAuthorsOfSciDocFilter}
      />
    );
  }

  return WithFeatureSwitchersHOC;
};

export default withFeatureSwitchers;
